import { GuestGuard } from '@/components/auth'
import { Ghost } from 'lucide-react'
import { Outlet } from 'react-router-dom'

export function AuthLayout() {
  return (
    <GuestGuard>
      <div className="min-h-screen flex">
        {/* Left side - Branding */}
        <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-ghost-600 to-ghost-900 text-white p-12 flex-col justify-between">
          <div className="flex items-center gap-3">
            <Ghost className="h-10 w-10" />
            <div className="flex items-center gap-2">
              <span className="text-2xl font-bold">GhostFlow</span>
              <span className="rounded bg-blue-500/20 px-2 py-0.5 text-xs font-semibold text-blue-300 uppercase tracking-wide">Beta</span>
            </div>
          </div>
          
          <div className="space-y-6">
            <h1 className="text-4xl font-bold leading-tight">
              The Ultimate Traffic<br />Management Platform
            </h1>
            <p className="text-xl text-ghost-200">
              High-performance click tracking, AI-powered cloaking, 
              and real-time analytics — all in one platform.
            </p>
            
            <div className="grid grid-cols-3 gap-8 pt-8">
              <div>
                <div className="text-3xl font-bold">&lt;10ms</div>
                <div className="text-ghost-200">Latency</div>
              </div>
              <div>
                <div className="text-3xl font-bold">99.9%</div>
                <div className="text-ghost-200">Uptime</div>
              </div>
              <div>
                <div className="text-3xl font-bold">5M+</div>
                <div className="text-ghost-200">Clicks/day</div>
              </div>
            </div>
          </div>
          
          <div className="text-sm text-ghost-300">
            © 2026 GhostFlow. All rights reserved.
          </div>
        </div>
        
        {/* Right side - Auth forms */}
        <div className="flex-1 flex items-center justify-center p-8">
          <div className="w-full max-w-md">
            {/* Mobile logo */}
            <div className="lg:hidden flex items-center justify-center gap-2 mb-8">
              <Ghost className="h-8 w-8 text-ghost-600" />
              <div className="flex items-center gap-2">
                <span className="text-xl font-bold">GhostFlow</span>
                <span className="rounded bg-blue-500/10 px-1.5 py-0.5 text-[10px] font-semibold text-blue-500 uppercase tracking-wide">Beta</span>
              </div>
            </div>
            
            <Outlet />
          </div>
        </div>
      </div>
    </GuestGuard>
  )
}
